import { Text } from '@uhg-abyss/web/ui/Text';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getFormattedPhoneNumber } from '../../../utils/phone.utils';
import { IconAlignmentContainer } from './ProviderLocation.style';
import {
  FaxDropDown,
  IconSymbolContainer,
  PhoneAllContainer,
  PhoneContainer,
  PhoneNumberContainer,
  infoSubTextContainer,
} from './ProviderLocationsDetails.style';

interface CheckboxOption {
  label: string;
  value: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

interface MenuItem {
  checkboxes: CheckboxOption[];
}

type FaxSectionProps = {
  fax: string[] | undefined;
  notAvailableOrUnknownText: string;
  fontSize: any;
  headingStyle: any;
  descriptionStyle: any;
};

export const FaxSection = ({
  fax,
  notAvailableOrUnknownText,
  fontSize,
  headingStyle,
  descriptionStyle,
}: FaxSectionProps) => {
  const { t } = useTranslation();
  const [selectedFaxIndex, setSelectedFaxIndex] = useState(0);
  const menuItems = [
    {
      checkboxes: fax?.map((faxNumber, index) => ({
        label: getFormattedPhoneNumber(faxNumber),
        value: `fax-${index + 1}`,
        checked: selectedFaxIndex === index,
        onChange: () => setSelectedFaxIndex(index),
      })),
    },
  ];

  return (
    <IconAlignmentContainer>
      <PhoneAllContainer>
        <IconSymbolContainer
          color="$core.color.brand.100"
          icon="call"
          size={18}
        />
        <PhoneContainer css={headingStyle}>
          {t('SHARE_PDF.Fax')}
          <PhoneNumberContainer style={{ width: 'fit-content' }}>
            {fax && fax?.length > 0 ? (
              fax?.length === 1 ? (
                // Directly display the single fax number
                <a
                  data-auto-testid="fax-single"
                  data-testid="fax-provider-locations-tab"
                  href={`fax:${fax[0]}`}
                  style={{
                    ...fontSize,
                    display: 'inline-block',
                  }}
                >
                  {getFormattedPhoneNumber(fax?.[0])}
                </a>
              ) : (
                // Display dropdown for multiple fax numbers
                <FaxDropDown
                  data-auto-testid="fax-multiple"
                  data-testid="multiple-fax-provider-locations-tab"
                  label={getFormattedPhoneNumber(fax[selectedFaxIndex])}
                  menuItems={menuItems as MenuItem[]}
                />
              )
            ) : (
              // Fallback for no fax numbers
              <Text
                css={{
                  ...infoSubTextContainer(false),
                  ...descriptionStyle,
                }}
                data-testid="fax-provider-locations-tab-not-available"
              >
                {notAvailableOrUnknownText}
              </Text>
            )}
          </PhoneNumberContainer>
        </PhoneContainer>
      </PhoneAllContainer>
    </IconAlignmentContainer>
  );
};
